import { Button } from '@/atoms/Button'
import { ParagraphMD, TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { Page } from '../../components/Page'
import { PageSection } from '../../components/PageSection'
import { TorchApplicationData, useTorchApplication } from '../../components/TorchApplicationContext'
import { FilmmakerApplication } from './FilmakerApplication'
import { FilmmakerAgreementButton } from './FilmmakerAgreementButton'

const useJotFormDataValidationText = (data: TorchApplicationData | null | undefined) => {
  const { t } = useTranslate('guild-create')

  const dataValidationErrors = []

  const [firstName = ''] = data?.filmmakerName?.split(' ') || []
  if (!firstName) {
    dataValidationErrors.push(t('firstNameRequired', 'First name is required'))
  }

  if (!data?.filmmakerEmail) {
    dataValidationErrors.push(t('emailRequired', 'Email is required'))
  }

  if (!data?.addressLine1) {
    dataValidationErrors.push(t('addressRequired', 'Address is required'))
  }

  if (!data?.city) {
    dataValidationErrors.push(t('cityRequired', 'City is required'))
  }

  if (!data?.state) {
    dataValidationErrors.push(t('stateRequired', 'State is required'))
  }

  if (!data?.zipCode) {
    dataValidationErrors.push(t('zipCodeRequired', 'Zip code is required'))
  }

  if (!data?.country) {
    dataValidationErrors.push(t('countryRequired', 'Country is required'))
  }

  if (!data?.filmmakerRole) {
    dataValidationErrors.push(t('filmmakerRoleRequired', 'Filmmaker role is required'))
  }

  if (!data?.title) {
    dataValidationErrors.push(t('titleRequired', 'Title is required'))
  }

  if (!data?.productionType) {
    dataValidationErrors.push(t('productionTypeRequired', 'Production type is required'))
  }

  if (!data?.companyName) {
    dataValidationErrors.push(t('companyNameRequired', 'Company name is required'))
  }

  return dataValidationErrors
}

export const Agreement = () => {
  const { t } = useTranslate('guild-create')
  const { setPage, data } = useTorchApplication()
  const formErrors = useJotFormDataValidationText(data)

  const hasSigned = !!data?.signatureDate

  return (
    <Page disabled={!hasSigned} onBack={() => setPage(2)} onNext={() => setPage(4)}>
      <PageSection className="flex flex-col items-center justify-center gap-8">
        <TitleMD weight="bold" className="px-6">
          {t('page3TermsConditionsSubmissionAgreement', 'Terms, Conditions, & Submission Agreement')}
        </TitleMD>
        {!!formErrors?.length && (
          <div>
            <ParagraphMD weight="bold" className="text-red-400">
              {t('pleaseFillInOrReenterData', 'Please fill in or retype the following fields on the previous page')}
            </ParagraphMD>
            <div className="flex flex-col gap-2 pl-4 pt-4">
              {formErrors.map((errorText) => (
                <ParagraphMD key={errorText} className="text-red-400">
                  * {errorText}
                </ParagraphMD>
              ))}
            </div>
          </div>
        )}
        {hasSigned ? <FilmmakerApplication /> : <FilmmakerAgreementButton disabled={!!formErrors.length} />}
      </PageSection>

      {hasSigned && (
        <Button variant="oxide" onClick={() => setPage(4)} className="w-72">
          {t('continue', 'Continue')}
        </Button>
      )}
    </Page>
  )
}
